import { sendSentryClientErrorOnce } from 'shared/lib';

import type { TProductTypePayload } from './productTypePayload.types';
import type { TProductTypeTabId } from './productTypeTab.types';
import { PRODUCT_TYPE_TAB_PAYLOADS } from './productTypeTabs.config';

export const getProductTypePayloadByTabId = (tabId: TProductTypeTabId): TProductTypePayload => {
  const tab = PRODUCT_TYPE_TAB_PAYLOADS.find(({ id }) => id === tabId);

  if (!tab) {
    sendSentryClientErrorOnce('getProductTypePayloadByTabId', 'Unknown product type tab id', { tabId });

    const [fallbackTab] = PRODUCT_TYPE_TAB_PAYLOADS;

    return {
      selectedProductType: fallbackTab.selectedProductType,
      purposeValue: fallbackTab.purpose,
    };
  }

  return {
    selectedProductType: tab.selectedProductType,
    purposeValue: tab.purpose,
  };
};
